import { defineComponent as _defineComponent } from 'vue'
import { mdiCloseCircle } from '@mdi/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalWrapper',
  props: {
    isShow: { type: Boolean, default: false },
    modalWidth: { default: '630px' },
    contentClass: { default: 'white' }
  },
  emits: ["update:isShow"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update:isShow', value: boolean): void }), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit, mdiCloseCircle }
}

})